<script>
export default {
    props: [ "data" ],
    name: "list",
    data() {
        return {};
    },
    computed: {
        toNumber(){
            return str => {
                return parseFloat(str).toFixed(2).toLocaleString();
            }
        },
        href(){
            return (item) => {
                return `/detail?id=${item.id}&color=${item.color[item.activeIndex].name}`
            }
        },
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="list">
        <div class="item" v-for="(item, index) in data" :key="index">
            <router-link class="cover_wrap" :to="href(item)">
                <div class="cover" :style="{backgroundImage: `url(${item.color[item.activeIndex].image})`}"></div>
                <div class="cover type2" :style="{backgroundImage: `url(${item.color[item.activeIndex].image2})`}"></div>
            </router-link>
            <div class="name_wrap">
                <div class="name"><router-link :to="href(item)">{{item.name}}</router-link></div>
                <div class="price pc" v-if="item.price != '999.00'">€ {{toNumber(item.price)}}</div>
            </div>
            <div class="colors" v-if="item.color.length > 1">
                <div class="color" 
                v-for="(_item, _index) in item.color" :key="_index" 
                :style="{backgroundColor: _item.color_code}" 
                :class="{active: item.activeIndex == _index, white: _item.color_code == '#ffffff'}" 
                @click="item.activeIndex = _index"></div>
            </div>
            <div class="price mobile" v-if="item.price != '999.00'">€ {{toNumber(item.price)}}</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.list{
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    .mobile{
        display: none;
    }
    .item{
        // width: 25%;
        width: calc((100% - 40px) / 3);
        // padding: 0 25px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
        // font-weight: bold;
        &:hover{
            .name{
                a{
                    border-bottom: 1px solid #000;
                }
            }
        }
        .cover_wrap{
            position: relative;
            padding-bottom: 125%;
            display: block;
            margin-bottom: 10px;
            .cover{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                &.type2{
                    opacity: 0;
                    transition: opacity .3s;
                }
            }
            &:hover{
                .cover{
                    &.type2{
                        opacity: 1;
                    }
                }
            }
        }
        .name_wrap{
            display: flex;
            padding-right: 20px;
            margin-bottom: 10px;
        }
        .name{
            font-size: 12px;
            // margin-bottom: 20px;
            // font-weight: bold;
            flex: 1;
        }
        .colors{
            display: flex;
            // margin-bottom: 20px;
            .color{
                width: 8px;
                height: 8px;
                margin-right: 8px;
                position: relative;
                cursor: pointer;
                &.white{
                    border: 1px solid #dfdfdf;
                }
                &.active{
                    &::after{
                        content: "";
                        display: block;
                        width: 10px;
                        height: 10px;
                        border: 1px solid #777;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }
    }
    @media screen and (max-width: 768px) {
        justify-content: space-between;
        gap: 0;
        .mobile{
            display: block;
        }
        .pc{
            display: none;
        }
        .item{
            width: 3.4rem;
            padding: 0;
            margin-bottom: .7rem;
            &:hover{
                .name{
                    a{
                        border: none;
                    }
                }
            }
            .cover_wrap{
                margin-bottom: .15rem;
                &:hover{
                    .cover{
                        &.type2{
                            opacity: 0;
                        }
                    }
                }
            }
            .name_wrap{
                padding-right: 0;
                margin-bottom: .15rem;
            }
            .name{
                font-size: .24rem;
                // margin-bottom: .15rem;
            }
            .colors{
                margin-bottom: .15rem;
                .color{
                    width: .12rem;
                    height: .12rem;
                    margin-right: .12rem;
                    &.active{
                        &::after{
                            width: .18rem;
                            height: .18rem;
                        }
                    }
                }
            }
        }
    }
}
</style>